import { Table } from "antd";

const ExpandedRow = ({ data, columns }) => {
  if (!data) return <div style={{ padding: 20 }}>Loading...</div>;

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      tableLayout="fixed" 
      bordered
      size="small"
      showHeader={false}
    />
  );
};


export default ExpandedRow;
